import { useContext } from 'react';
import { ProjectsContext } from 'src/app/providers/ProjectProvider';
import { TableContext } from 'src/app/providers/TableProvider';
import { UserContext } from 'src/app/providers/UserProvider';
import AuthService from 'src/shared/api/auth/AuthService';
import TokenService from 'src/shared/api/token/TokenService';
import { resetWorkspaceState } from 'src/shared/lib/session/resetWorkspaceState';

export const useLogout = () => {
  const {
    setForms,
    setSelectedForm,
    setSelectedProject,
    setTableSettings,
    setProjects,
    setIsProjectsLoading,
    setIsFormsLoading,
    setIsTableSettingsLoading,
  } = useContext(ProjectsContext);
  const { setUser } = useContext(UserContext);
  const { setTableData } = useContext(TableContext);

  const handleLogout = async () => {
    try {
      await AuthService.logout();
    } catch (e) {
    } finally {
      resetWorkspaceState({
        setProjects,
        setForms,
        setSelectedProject,
        setSelectedForm,
        setTableSettings,
        setTableData,
        setIsProjectsLoading,
        setIsFormsLoading,
        setIsTableSettingsLoading,
      });

      TokenService.removeTokens();
      setUser(null);
    }
  };

  return { handleLogout };
};
